import React, { useState, useEffect } from 'react';

const SectionNav = ({ t }) => {
  const [activeId, setActiveId] = useState('hero');

  const navItems = [
    { id: 'hero', label: t.nav.hero },
    { id: 'part1', label: t.nav.part1 },
    { id: 'part2', label: t.nav.part2 },
    { id: 'part3', label: t.nav.part3 },
    { id: 'effort', label: t.nav.effort },
    { id: 'breakeven', label: t.nav.breakeven },
    { id: 'questions', label: t.nav.questions }
  ];

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveId(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    navItems.forEach((item) => {
      const element = document.getElementById(item.id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, [t]);

  return (
    <nav className="fixed right-8 top-1/2 -translate-y-1/2 z-[100] hidden lg:flex flex-col gap-6 group" aria-label="Section navigation">
      {navItems.map((item) => {
        const isActive = activeId === item.id;
        return (
          <a
            key={item.id}
            href={`#${item.id}`}
            aria-current={isActive ? 'true' : 'false'}
            className="flex items-center justify-end gap-4 group/item relative h-10 outline-none"
          >
            <span className={`text-[10px] font-extrabold uppercase tracking-[0.2em] whitespace-nowrap transition-all duration-500 ${
              isActive 
                ? 'opacity-100 translate-x-0 text-teal-600' 
                : 'opacity-0 translate-x-8 group-hover:opacity-60 text-navy-800'
            }`}>
              {item.label}
            </span>
            <div className={`w-3 h-3 rounded-full transition-all duration-500 border-2 ${
              isActive 
                ? 'bg-teal-500 border-teal-500 scale-150 shadow-lg shadow-teal-500/50' 
                : 'bg-transparent border-navy-200 group-hover/item:border-navy-400 group-hover/item:scale-125'
            }`} />
          </a>
        );
      })}
    </nav>
  );
};

export default SectionNav;